import { Group } from './group.model';
import { ToolSet } from './toolSet.model';
import { Line } from '@models/line.model';
import { Issue } from '@models/issue.model';
import { User } from '@app/shared/models';
import { ToolDetails } from '@app/tool/model/toolDetails.model';
import { ToolDocuments } from '@app/tool/model/toolDocuments.model';
import { ToolIntervention } from '@app/tool/model/toolIntervention.model';
import { ToolStorage } from '@app/tool/model/toolLocation.model';
import { ToolPosition } from '@app/tool/model/tool-position.model';
import {StrainMeasurement} from "@app/strain/common/models/strain-registry-measurement.model";

export class Tool {
    public id: number;
    public toolUid = '';
    public name: string;
    public inUse = false;
    public mainLine: Line;
    public owner: User;
    public issue: Issue;
    public status: string;
    public stance: string;
    public reason: string;
    public mesCode: string;
    public supplierCode: string;
    public inventoryNumber: string;
    public toolControlName: string;
    public codingType: string;
    public isAvailableForManufactoring: boolean;
    public isAlreadyReservedForLine: boolean;
    public isToolInTransport: boolean;
    public shouldBeReplaced: boolean;
    public lineSwitch: boolean;
    public setSize: number;
    public details: ToolDetails;
    public documents: ToolDocuments;
    public interventions: ToolIntervention[];
    public strainMeasurements: StrainMeasurement[]
    public isNeededAtLine: boolean;
    public isAlreadyAtLine: boolean;
    public isScanned: boolean;
    public isSpare: boolean;
    public reasonForReplacement: string;
    public liftNumber: string;
    public liftShelf: string;
    public shelfPosition: string;
    public isDeleted: boolean;
    public line: Line;
    public isInStorage: boolean;
    public registeredTime: number;
    public registeredCycles: number;
    public notAvailableReason: number;
    public cart: number;
    public deleteComment: string;
    public validateComment: string;
    public invalidateComment: string;
    public position: ToolPosition;
    public positionLabel: string;
    public excludedFromReturn: boolean;
    public isToolStationedAtERSA: boolean;
    public idFromSet: number;
    public toolDetailsId: number;
    public maintenancePlanId: number;
    public toolReturnId: number;
    // TODO Speed hack for disabling a row in the table
    public disabled = false;
    public selected = false;

    public rowMainLineColor = false;
    public rowSecondaryLineColor = false;

    private parent: ToolSet | Group;

    static mapLine(line = {}) {
        return new Line(line || {});
    }

    static mapToolLocation(location = {}) {
        return new ToolStorage(location);
    }

    constructor(tool: any = {}, parent?: ToolSet | Group) {
        this.id = tool.id;
        this.toolUid = tool.toolUid || '';
        this.name = tool.name || '';
        this.owner = tool.owner;
        this.issue = tool.issue;
        this.status = tool.status;
        this.stance = tool.stance;
        this.isAvailableForManufactoring = tool.isAvailableForManufactoring;
        this.isAlreadyReservedForLine = tool.isAlreadyReservedForLine;
        this.isToolInTransport = tool.isToolInTransport;
        this.shouldBeReplaced = tool.shouldBeReplaced;
        this.setSize = tool.setSize || '';
        this.mesCode = tool.mesCode || '';
        this.inventoryNumber = tool.inventoryNumber || '';
        this.toolControlName = tool.toolControlName || '';
        this.codingType = tool.codingType || '';
        this.supplierCode = tool.supplierCode;
        this.mainLine = Tool.mapLine(tool.mainLine);
        this.documents = tool.documents;
        this.parent = parent;
        this.isNeededAtLine = tool.isNeededAtLine;
        this.isAlreadyAtLine = tool.isAlreadyAtLine;
        this.isScanned = tool.isScanned;
        this.toolReturnId = tool.toolReturnId;
        this.isSpare = tool.isSpare;
        this.reasonForReplacement = tool.reasonForReplacement;
        this.details = new ToolDetails(tool.details);
        this.isDeleted = tool.isDeleted;
        this.line = tool.line;
        this.isInStorage = tool.isInStorage;
        this.cart = tool.cart;
        this.deleteComment = tool.deleteComment;
        this.validateComment = tool.validateComment;
        this.invalidateComment = tool.invalidateComment;
        this.position = tool.position ? new ToolPosition(tool.position) : null;
        this.toolDetailsId = tool.toolDetailsId;
        this.maintenancePlanId = tool.maintenancePlanId;
        // Backend was not smart @ all (use ToolStorage object ffs)
        this.liftNumber = tool.liftNumber || 0;
        this.liftShelf = tool.liftShelf || 0;
        this.shelfPosition = tool.shelfPosition || '';

        this.positionLabel = this.position && this.position.slot ? this.position.slot.label : null;

        this.selected = tool.isSelected || tool.selected || false;

        this.registeredCycles = tool.registeredCycles || 0;
        this.registeredTime = tool.registeredTime || 0;
        this.notAvailableReason = tool.notAvailableReason;
        this.excludedFromReturn = tool.excludedFromReturn || false;
        this.isToolStationedAtERSA = tool.isToolStationedAtERSA || false;
        this.idFromSet = tool.idFromSet || 0;
        this.strainMeasurements = tool.strainMeasurements || [];
    }

    get identifierName() {
        return `${this.name} - ${this.toolUid}`;
    }

    get type() {
        return 'tool';
    }

    get compoundName() {
        return this.name + ' - ' + this.toolUid + ' - ' + this.mainLine.name;
    }

    get toolUidAndSetId() {
        return this.idFromSet === null || this.idFromSet === 0 ? this.toolUid : `${this.toolUid} - ${this.idFromSet}`
    }
}
